const Heading = ({text, className}: {text: string, className?: string}) => {
    return (
        <h1 className={`secHeading ${className || ''}`}>{text}</h1>
    )
}

export default Heading;